import { Controller } from "@hotwired/stimulus";

// A toggle that confirms before enabling. Turning the toggle ON is held back
// behind a confirmation modal (for billable add-ons); turning it OFF submits
// immediately. Server re-renders the toggle as the source of truth.
export default class extends Controller {
  static targets = ["checkbox", "disableForm", "modalTrigger"];

  connect() {
    if (window.$) {
      $(this.checkboxTarget).closest(".ui.checkbox").checkbox();
    }
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.checkboxTarget.checked = false;
      this.modalTriggerTarget.click();
    } else {
      this.disableFormTarget.requestSubmit();
    }
  }
}
